import React from 'react';
import { convertToRaw } from 'draft-js';

class Debug extends React.Component {
    render() {
        const { editorState } = this.props;
        return (
            <pre className="debug">
                debug:
                <br />
                {JSON.stringify(convertToRaw(editorState.getCurrentContent()), undefined, 2)}
            </pre>
        );
    }
}

export default Debug;
